import { useState, useEffect, useRef } from 'react';

const useDropdown = ({ disableClickOutside = false, defaultRefMenu = null, defaultRefBtn = null }) => {
  const [isOpen, setIsOpen] = useState(false);
  const refMenu = useRef(defaultRefMenu);
  const refBtn = useRef(defaultRefBtn);

  const handleClickOutside = (event) => {
    if (!refMenu.current || !refBtn.current) return;
    if (!refBtn.current.contains(event.target) && !refMenu.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    if (disableClickOutside) return;
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [disableClickOutside]);

  return {
    isOpen,
    setIsOpen,
    refMenu,
    refBtn,
  };
};

export default useDropdown;
